<template>
  <div class="tw-z-0 tw-relative tw-h-full" v-click-outside="onClickOutside">
    <div class="tw-flex-1 tw-h-full tw-px-4 tw-flex tw-items-center tw-justify-between sm:tw-px-6 lg:tw-max-w-6xl lg:tw-mx-auto lg:tw-px-8">
      <div class="tw-flex-1 tw-flex">
        <form class="tw-w-full tw-flex md:tw-ml-0" action="#" method="GET">
          <label for="search-field" class="tw-sr-only">Search</label>
          <div class="tw-relative tw-w-full tw-text-gray-400 focus-within:tw-text-gray-600">
            <div class="tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pointer-events-none" aria-hidden="true">
              <base-spinner v-if="isLoading" :size="20" />
              <search-icon class="tw-h-5 tw-w-5 tw-transition-colors tw-duration-100" v-else />
            </div>
            <input
              id="search-field"
              name="search-field"
              class="tw-block tw-w-full tw-h-full tw-pl-8 tw-pr-3 tw-py-2 tw-border-transparent tw-text-gray-900 tw-placeholder-gray-500 focus:tw-outline-none focus:tw-ring-0 focus:tw-border-transparent sm:tw-text-sm"
              :placeholder="memberSearchPlaceholder"
              type="search"
              v-model="query"
            />
          </div>
        </form>
      </div>
    </div>
    <transition
      enter-active-class="tw-transtion tw-ease-out tw-duration-200"
      enter-class="tw-opacity-0 tw--translate-y-1"
      enter-to-class="tw-opacity-100 tw-translate-y-0"
      leave-active-class="tw-transtion tw-ease-in tw-duration-150"
      leave-class="tw-opacity-100 tw--translate-y-0"
      leave-to-class="tw-opacity-0 tw-translate-y-1"
    >
      <div
        class="tw-absolute tw-mt-0.5 tw-z-10 tw-w-full tw-inset-x-0 tw-transform tw-shadow-lg tw-bg-white tw-rounded sm:tw-left-5 lg:tw-max-w-6xl lg:tw-mx-auto lg:tw-left-7"
        v-show="showDropdown && !isLoading"
      >
        <div v-if="customers.length">
          <div
            v-for="customer in customers"
            :key="customer.userId"
            class="tw-px-4 tw-py-2.5 hover:tw-bg-gray-100 tw-transition-colors tw-duration-100 tw-cursor-pointer"
            @click="goToMember(customer.userId)"
          >
            <div>{{ customer.fullName }}</div>
            <div class="tw-flex tw-flex-row">
              <div class="tw-text-xs tw-text-gray-500 tw--mt-1">{{ customer.email }}</div>
              <base-phone-number-field class="tw-text-xs tw-text-gray-500 tw--mt-1 tw-ml-2" :value="customer.phone" :isHyperlinkActive="false" />
            </div>
          </div>
        </div>
        <div class="tw-flex tw-justify-center tw-text-gray-500 tw-p-4" v-else>
          No results
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { debounce } from "debounce";
import vClickOutside from "v-click-outside";
import { mapGetters } from "vuex";
import { SearchIcon } from "@/assets/svgs";

export default {
  components: { SearchIcon },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    businessId: String,
  },
  data() {
    return {
      query: "",
      showDropdown: false,
      isLoading: false,
      customers: [],
    };
  },
  computed: {
    ...mapGetters("organization", ["organization"]),
    memberSearchPlaceholder() {
      return `Search ${this.organization.customerLabelPlural}`;
    },
  },
  watch: {
    query() {
      if (this.query.length > 0) {
        this.getMembers();
      } else {
        this.showDropdown = false;
        this.customers = [];
      }
    },
  },
  methods: {
    getMembers: debounce(function() {
      this.isLoading = true;
      this.showDropdown = true;
      this.$axios
        .get(`/businesses/${this.businessId}/members/?skip=0&take=10&query=${encodeURIComponent(this.query)}`)
        .then((res) => {
          this.isLoading = false;
          const { items = [] } = res.data;
          this.customers = items;
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
          debugger;
        });
    }, 500),
    goToMember: function(id) {
      let path;
      if (this.organization.usePrescriptionProgramSetting) {
        path = `/businesses/${this.businessId}/members/${id}/prescriptions`;
      } else {
        path = `/businesses/${this.businessId}/members/${id}/plans`;
      }
      if (this.$route.path !== path) {
        this.$router.push(path);
        this.showDropdown = false;
        setTimeout(() => {
          this.query = "";
        }, 150);
      }
    },
    onClickOutside() {
      this.showDropdown = false;
    },
    didFocus() {
      if (this.query) {
        this.showDropdown = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/vars.scss";

#MemberSearchDropdown {
  position: absolute;
  top: 40px;
}

.spinner {
  min-width: 100px;
}
</style>
